import React, { Component } from "react";
import { Link } from "react-router-dom";

class IconBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      iconbox: [
        {
          id: 1,
          icon: "autora-icon-quality",
          srcimg: "assets/img/homepage/CityXBiz_Icon.png",
          title: "CITYX BIZ",
          text: "Partnerska mobilna aplikacija koja služi za upravljanje sadržajem. Neograničeni broj zaposlenika, jednostavan i intutivan dizajn - i sve to kao dio paketa bez nadoplate!",
        },
        {
          id: 2,
          icon: "autora-icon-time",
          srcimg: "assets/img/homepage/CityXCMS_Icon.png",
          title: "CITYX CMS",
          text: "Kao desktop rješenje razvili smo CMS s kojim upravljate svim svojim poslovnim procesima. Od upravljanja s ovlastima Vaših administratora do sadržaja.",
        },
        {
          id: 3,
          icon: "autora-icon-author",
          srcimg: "assets/img/homepage/CityXPay_Icon.png",
          title: "CITYX PAY",
          text: "Payment je modul koji je moguće povezati sa svim funkcionalnostima i aplikacijama koje nudimo. Nakon ugovaranja suradnje s CityX-om, Vaša naplata može krenuti. Bez dodatnih ugovora s kartičarima!",
        },
      ],
    };
  }

  render() {
    return (
      <div className="row">
        {this.state.iconbox.map((data) => (
          <div className="col-md-4" key={data.id}>
            <div
              className="themesflat-spacer clearfix"
              data-desktop={0}
              data-mobile={0}
              data-smobile={35}
            />
            <div
              className="themesflat-content-box clearfix"
              data-margin="0 5px 0 5px"
              data-mobilemargin="0 0 0 0"
            >
              <div className="themesflat-icon-box icon-top align-center has-width w95 circle light-bg accent-color style-1 clearfix">
                <div className="icon-wrap" style={{}}>
                  <img
                    src={data.srcimg}
                    alt="imagealt"
                    style={{
                      borderRadius: "20px",
                      border: "1px solid silver",
                    }}
                  />
                </div>
                <div className="text-wrap">
                  <h5 className="heading">
                    <Link to="#">{data.title}</Link>
                  </h5>
                  <div className="sep clearfix" />
                  <p className="sub-heading">{data.text}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default IconBox;
